import { LogLevel } from './LogLevel'

export class BaseAppender {
  level: LogLevel = LogLevel.INFO
  protected shouldLog(level: LogLevel): boolean {
    return level >= this.level
  }
}
